<!--  -->
<template>
  <div>
    <el-table
      v-loading="loading"
      :data="tabledata"
      border
      max-height="450"
    >
      <el-table-column
        prop="account_name"
        label="账户名称"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.show">{{ scope.row.accountName }}</span>
          <el-input
            v-else
            v-model="textName"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="account_name"
        label="密码"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover
            v-if="!scope.row.show"
            placement="top-start"
            title="密码"
            width="200"
            trigger="hover"
            :content="scope.row.pwd"
          >
            <!-- <el-button slot="reference">hover 激活</el-button> -->
            <span slot="reference" class="ellipsis_box">{{ scope.row.pwd }}</span>
          </el-popover>

          <el-input
            v-else
            v-model="password"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-for="value,name,index in tabledata.length ? tabledata[0].decode_data : null"
        :key="index"
        :prop="value"
        :label="name"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.show">{{ scope.row.decode_data[name] }}</span>
          <el-input
            v-else
            v-model="modifyDataQuery[name]"
          />
        </template>
      </el-table-column>

      <el-table-column
        :key="mathRandom"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <span v-show="!scope.row.show">
            <el-button
              type="warning"
              size="mini"
              @click.native.prevent="modifyAccount(scope.$index, scope.row)"
            >
              修改
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click.native.prevent="deleter(scope.$index,scope.row)"
            >
              删除
            </el-button>
          </span>
          <span v-show="scope.row.show">
            <el-button
              type="text"
              size="small"
              @click.native.prevent="cancel(scope.$index, scope.row)"
            >
              取消修改
            </el-button>
            <el-button
              type="text"
              size="small"
              @click.native.prevent="confirm(scope.$index, scope.row)"
            >
              确认修改
            </el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { accountindex, accountstoreupdata, accountdestroy } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      platform_ids: null,
      tabledata: [],
      modifyDataQuery: {},
      mathRandom: null,
      actionId: null,
      textName: '',
      status: null,
      password: '',
      loading: false
    }
  },
  watch: {
    platformid: function(newVal, oldVal) {
      this.platform_ids = newVal
      this.getlist()
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    updata() {
      this.getlist()
    },
    async getlist() {
      this.loading = true
      const data = await accountindex({
        platform_id: this.platform_ids
      })
      this.loading = false
      this.tabledata = data.data == null ? [] : data.data
      for (let i = 0; i < this.tabledata.length; i++) {
        this.tabledata[i].show = false
      }
    },
    modifyAccount(index, data) {
      this.modifyDataQuery = { ...data.decode_data }
      for (let i = 0; i < this.tabledata.length; i++) {
        this.tabledata[i].show = false
      }
      this.tabledata[index].show = true
      this.actionId = data.id
      this.textName = data.accountName
      this.status = data.status
      this.password = data.pwd
      this.mathRandom = Math.random()
    },
    cancel(index, item) {
      this.tabledata[index].show = false
      this.mathRandom = Math.random()
    },
    rule(obj) {
      for (var key in obj) {
        if (obj[key] === '') {
          return false
        }
      }
      return true
    },
    async confirm(index, item) {
      if (this.textName === '') {
        this.$message({
          message: '请输入账户名称',
          type: 'error'
        })
        return
      }
      if (this.password === '') {
        this.$message({
          message: '请输入密码',
          type: 'error'
        })
        return
      }
      const flagValue = this.rule(this.modifyDataQuery)
      if (!flagValue) {
        this.$message({
          message: '任一输入项都不能为空',
          type: 'error'
        })
      }
      // this.tabledata[index].show = false
      // this.mathRandom = Math.random()
      await accountstoreupdata({
        id: this.actionId,
        struct_data: this.modifyDataQuery,
        status: this.status,
        pwd: this.password,
        account_name: this.textName
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.getlist()
    },
    deleter(index, item) {
      this.$confirm('此操作将删除此消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        accountdestroy({
          id: item.id
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getlist()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.ellipsis_box{
  height: 43px;
  display: block;
  overflow: hidden;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
